import { render } from "./SubItem.vue?vue&type=template&id=66f48a76&scoped=true"
import script from "./SubItem.vue?vue&type=script&lang=js"
export * from "./SubItem.vue?vue&type=script&lang=js"

import "./SubItem.vue?vue&type=style&index=0&id=66f48a76&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f48a76"]])

export default __exports__